import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { FButton, FDialog, FGrid, FGridItem } from "ferrum-design-system";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";
import { addToken } from "./../../../../container-components/web3Client/types";
import { BsCheck2Circle } from "react-icons/bs";
import { IoAddCircleOutline } from "react-icons/io5";
import { MsAddTokenDialog } from "../select-token/AddTokenDialog";
import * as SwapActions from "../../../../redux/slices/swap";
import Loader from "../../../../assets/img/loader-m.png";
import useTokenBalance from "../../../../hooks/useTokenBalance";
import { useWalletConnector } from "foundry";

export const MsTokenListDialog = ({
  show,
  onHide,
  networks,
  tokensList,
  selectorDialogFor,
  setQuoteLoading,
}: {
  show: any;
  onHide: any;
  networks: any;
  tokensList: any;
  selectorDialogFor: any;
  setQuoteLoading: any;
}) => {
  const dispatch = useDispatch();
  const [showAddTokenDialog, setShowAddTokenDialog] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { walletAddress } = useWalletConnector();
  const {
    fromInfo,
    toInfo,
    isFetchingTokensList,
    selectedNetwork,
    allTokens,
    tokenV2: authToken,
  } = useSelector((state: RootState) => ({
    ...state.swap,
    ...state.networks,
    ...state.walletAuthenticator,
  }));

  useEffect(() => {
    if (
      show &&
      (selectorDialogFor === "FROM_NETWORK" ||
        selectorDialogFor === "FROM_TOKEN")
    ) {
      setSearchValue("");
      getMeMySelection(
        fromInfo?.network?.chainId ? fromInfo?.network : selectedNetwork,
        fromInfo?.token
      );
    } else if (
      show &&
      (selectorDialogFor === "TO_NETWORK" || selectorDialogFor === "TO_TOKEN")
    ) {
      setSearchValue("");
      getMeMySelection(toInfo?.network, toInfo?.token);
    }
  }, [selectedNetwork, selectorDialogFor, show]);

  useEffect(() => {
    if (
      authToken &&
      searchValue &&
      walletAddress &&
      selectedNetwork &&
      selectorDialogFor &&
      fromInfo &&
      toInfo
    ) {
      dispatch(
        SwapActions.getTokenList(
          allTokens,
          selectorDialogFor === "FROM_NETWORK" ||
            selectorDialogFor === "FROM_TOKEN"
            ? fromInfo.network
            : toInfo.network,
          selectorDialogFor,
          fromInfo,
          toInfo,
          walletAddress,
          selectorDialogFor === "FROM_NETWORK" ||
            selectorDialogFor === "FROM_TOKEN"
            ? fromInfo.token
            : toInfo.token,
          searchValue,
          authToken as string
        )
      );
    }
  }, [searchValue]);

  const getMeMySelection = (network: any, token: any) => {
    dispatch(
      SwapActions.getTokenList(
        allTokens,
        network,
        selectorDialogFor,
        fromInfo,
        toInfo,
        walletAddress,
        token,
        "",
        ""
      )
    );
  };

  const TokenItem = ({
    item,
    networkRpc,
  }: {
    item: any;
    networkRpc: string;
  }) => {
    const { loading, tokenBalance } = useTokenBalance(
      walletAddress,
      item?.address,
      item?.isNative,
      networkRpc
    );

    return (
      <div
        className={`ms-currency 
         ${isFetchingTokensList ? "ms-currency-disabled" : "cursor-pointer"}`}
        onClick={() => {
          if (!isFetchingTokensList) {
            getMeMySelection(undefined, item);
            onHide();
          }
        }}
      >
        <span>
          {item.logoURI ? <img src={item.logoURI} alt={item.name} /> : null}
        </span>
        <div className={`ms-currency-info ${item?.symbol?.trim()}`}>
          <p>{item.symbol}</p>
          <small>{item.name}</small>
        </div>
        <p className="ms-currency-price f-pt--2">
          <div className="d-flex ai ai-items-center">
            {item.balance > 0 ? (
              <span className="custom-font-size-14 f-mr--5">
                {Number(item.balance).toFixed(6)}
              </span>
            ) : tokenBalance > 0 ? (
              <span className="custom-font-size-14 f-mr--5">
                {Number(tokenBalance).toFixed(6)}
              </span>
            ) : null}
            <IoAddCircleOutline
              color="#d9b373"
              size={18}
              onClick={() => {
                addToken(item);
              }}
            />
          </div>
        </p>
      </div>
    );
  };

  const isNetworkSelected =
    ((selectorDialogFor === "FROM_NETWORK" ||
      selectorDialogFor === "FROM_TOKEN") &&
      fromInfo?.network?.chainId) ||
    ((selectorDialogFor === "TO_NETWORK" || selectorDialogFor === "TO_TOKEN") &&
      toInfo?.network?.chainId);

  return (
    <div className="full-screen-mobile">
      <FDialog
        show={show}
        size={"large listtokenimg-m"}
        onHide={() => {
          onHide();
        }}
        variant={"token-list listtoken-m"}
        title="Token List"
      >
        <>
          <div className="ms-token-list-search">
            <FiSearch color="#6F767E" size={20} />
            <input
              type="search"
              inputMode="search"
              value={searchValue}
              placeholder="Search name or paste address"
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <FGrid>
            <FGridItem
              size={[4]}
              className="ms-tokens-list-networks m-list-token"
            >
              <div className="ms-tokens-list  m-tokens-list">
                {networks && networks.length ? (
                  networks.map((item: any) => {
                    return (
                      <div
                        className={`ms-token ${
                          ((selectorDialogFor === "FROM_NETWORK" ||
                            selectorDialogFor === "FROM_TOKEN") &&
                            fromInfo?.network?.name === item.name) ||
                          ((selectorDialogFor === "TO_NETWORK" ||
                            selectorDialogFor === "TO_TOKEN") &&
                            toInfo?.network?.name === item.name)
                            ? "ms-selected-network checklogobox"
                            : ""
                        }`}
                        id={item?._id}
                        onClick={() => {
                          getMeMySelection(item, undefined);
                          setSearchValue("");
                        }}
                      >
                        {item.logo ? (
                          <>
                            <img
                              className={`checklogo-m ${item?.name?.trim()}`}
                              src={item.logo}
                              alt={item.name}
                            />
                            {((selectorDialogFor === "FROM_NETWORK" ||
                              selectorDialogFor === "FROM_TOKEN") &&
                              fromInfo?.network?.name === item.name) ||
                            ((selectorDialogFor === "TO_NETWORK" ||
                              selectorDialogFor === "TO_TOKEN") &&
                              toInfo?.network?.name === item.name) ? (
                              <BsCheck2Circle
                                color="#DAB46E"
                                className="ms-selected-network-checked-icon"
                              />
                            ) : null}
                          </>
                        ) : null}
                        <p>{item.name}</p>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center">No Networks Available</div>
                )}
              </div>
            </FGridItem>
            {/* <div className="vertical-line" /> */}
            <FGridItem
              size={[7]}
              className={`ms-currency-list ms-currency-mobile ${
                isFetchingTokensList
                  ? "ms-currency-list-opacity"
                  : "ms-currency-list"
              }`}
            >
              {isFetchingTokensList ? (
                <img
                  className="ms-currency-list-loader"
                  src={Loader}
                  alt={"loading"}
                  style={{ width: 100, height: 100 }}
                />
              ) : tokensList && tokensList.length ? (
                tokensList.map((item: any) => (
                  <TokenItem
                    item={item}
                    networkRpc={
                      selectorDialogFor === "FROM_NETWORK" ||
                      selectorDialogFor === "FROM_TOKEN"
                        ? fromInfo?.network?.rpcUrl
                        : selectorDialogFor === "TO_NETWORK" ||
                          selectorDialogFor === "TO_TOKEN"
                        ? toInfo?.network?.rpcUrl
                        : ""
                    }
                  />
                ))
              ) : // ) : isNetworkSelected &&
              //   searchValue &&
              //   Web3.utils.isAddress(searchValue) &&
              //   importedToken?.name ? (
              //   <ImportTokenButton importTokenData={importedToken} />
              isNetworkSelected ? (
                <div className="ms-empty-currency-list">
                  <div className="ms-empty-currency-list-item">Not Found!</div>
                </div>
              ) : (
                <div className="ms-empty-currency-list">
                  <div className="ms-empty-currency-list-item">
                    Select Network
                  </div>
                </div>
              )}
            </FGridItem>
          </FGrid>
        </>
      </FDialog>
      <MsAddTokenDialog
        show={showAddTokenDialog}
        onHide={() => {
          setShowAddTokenDialog(false);
        }}
      />
    </div>
  );
};
